export default __webpack_public_path__ + "f27bd90bb47be7784dc289767115954d.svg";